import { render } from "./BFormLabel.vue?vue&type=template&id=4f3b4168"
import script from "./BFormLabel.vue?vue&type=script&lang=js"
export * from "./BFormLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/packs/components/BFormLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f3b4168"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f3b4168', __exports__)) {
    api.reload('4f3b4168', __exports__)
  }
  
  module.hot.accept("./BFormLabel.vue?vue&type=template&id=4f3b4168", () => {
    api.rerender('4f3b4168', render)
  })

}


export default __exports__